import { Aggregator } from "@src/pages/LocationPage/generator";
import { instance } from "./api";

export const settingsApi = {
  getPickupTime(restaurant_id: string) {
    return instance.get(`/v3/restaurant/${restaurant_id}/adjusted-pickup-time`);
  },
  updatePickupTime(restaurant_id: string, time: number) {
    const body = JSON.stringify({ time: time });
    return instance.put(
      `/v3/restaurant/group/${restaurant_id}/adjusted-pickup-time`,
      body
    );
  },
  updateRestaurantStatus(body: any) {
    return instance.post(`/v3/restaurant/store-management`, body);
  },
  getRestaurants(
    rest_id: string,
    page: number,
    aggregator: string,
    limit: number
  ) {
    return instance.get(
      `/v2/location/group/${rest_id}?aggregator=${aggregator}&page=${page}&limit=100`
    );
  },
  // TURN IN TURN OFF
  switchRestaurants(body: any) {
    return instance.put(`/v3/restaurant/store-management`, body);
  },
  editRestaurantSendToPos(body: {
    restaurant_id: string;
    aggregator: Aggregator;
    send_to_pos: boolean;
  }) {
    return instance.put(`/v3/restaurant/edit-sendtopos`, body);
  },

  getRestaurantSendToPos(restaurant_group_id: string, aggregator: string) {
    return instance.get(
      `/v3/restaurant/get-sendtopos?restaurant_group_id=${restaurant_group_id}&aggregator=${aggregator}`
    );
  },
  getBusyModes(restaurant_group_id: string) {
    return instance.get(`/v2/location/busy_mod/${restaurant_group_id}`);
  },
  setBusyMode(restaurant_id: string, additional_cooking_time: number) {
    return instance.post(`v2/location/busy_mod`, {
      restaurant_id,
      additional_cooking_time,
    });
  },
  deleteBusyMode(restaurant_id: string) {
    return instance.delete(`v2/location/busy_mod/${restaurant_id}`);
  },
  editRetryCount(restaurant_group_id: string, count: number) {
    return instance.patch(
      `v3/restaurant_group/retry-count/${restaurant_group_id}?retry_count=${count}`
    );
  },
  getRetryCount(restaurant_group_id: string) {
    return instance.get(`v3/restaurant_group/${restaurant_group_id}`);
  },
  setStoreAutoOpen(restaurant_id: string, is_open: boolean, delivery_type: string) {
    return instance.post(`v2/location/store_auto_open`, {
      restaurant_id,
      is_open,
      delivery_type,
    });
  },
};
